import { render } from "./Spaces.vue?vue&type=template&id=2b854da1&scoped=true"
import script from "./Spaces.vue?vue&type=script&lang=js"
export * from "./Spaces.vue?vue&type=script&lang=js"

import "./Spaces.vue?vue&type=style&index=0&id=2b854da1&scoped=true&lang=css"

import exportComponent from "/Users/pongsakornsomsri/workspace/neera-retreat-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b854da1"]])

export default __exports__